import { cn } from '@/lib/utils';
import {
  ASSIGN_ROW_DRAG_HINT,
  getAssignRowHint,
} from '@/pages/sale/lib/sale-assign-row-utils';
import { GripVertical } from 'lucide-react';

type AssignDragGripProps = {
  size?: 'sm' | 'md';
  className?: string;
};

export function AssignDragGrip({ size = 'md', className }: AssignDragGripProps) {
  return (
    <div
      className={cn(
        'mt-0.5 shrink-0 pointer-events-none select-none text-slate-300 transition group-hover:text-slate-500',
        className,
      )}
    >
      <GripVertical className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
    </div>
  );
}

type AssignRowHintProps = {
  tapAssignEnabled?: boolean;
  isSelected?: boolean;
  /** Visible on hover for pointer devices. */
  showDesktopHint?: boolean;
  /** Visible on small screens when tap-assign is enabled. */
  showMobileHint?: boolean;
  className?: string;
};

export function AssignRowHint({
  tapAssignEnabled = false,
  isSelected = false,
  showDesktopHint = true,
  showMobileHint = false,
  className,
}: AssignRowHintProps) {
  return (
    <>
      {showDesktopHint && (
        <span
          className={cn(
            'hidden text-[10px] text-slate-400 opacity-0 transition group-hover:opacity-100 md:inline',
            className,
          )}
        >
          {tapAssignEnabled ? getAssignRowHint(isSelected) : ASSIGN_ROW_DRAG_HINT}
        </span>
      )}
      {showMobileHint && tapAssignEnabled && (
        <span
          className={cn(
            'text-[10px] font-medium md:hidden',
            isSelected ? 'text-indigo-600' : 'text-slate-400',
            className,
          )}
        >
          {getAssignRowHint(isSelected)}
        </span>
      )}
    </>
  );
}
